/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monthly_Challenge_TitleInputs */

const en_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly Challenge`)
};

const ar_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحدي شهري`)
};

const de_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatliche Herausforderung`)
};

const es_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafío mensual`)
};

const fr_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Défi mensuel`)
};

const it_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfida mensile`)
};

const ja_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月間チャレンジ`)
};

const ko_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`월간 챌린지`)
};

const pt_br_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafio mensal`)
};

const ru_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячный челлендж`)
};

const th_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความท้าทายรายเดือน`)
};

const tr_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık Mücadele`)
};

const zh_cn_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本月挑战`)
};

const zh_tw_monthly_challenge_title = /** @type {(inputs: Monthly_Challenge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本月挑戰`)
};

/**
* | output |
* | --- |
* | "Monthly Challenge" |
*
* @param {Monthly_Challenge_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const monthly_challenge_title = /** @type {((inputs?: Monthly_Challenge_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthly_Challenge_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monthly_challenge_title(inputs)
	if (locale === "ar") return ar_monthly_challenge_title(inputs)
	if (locale === "de") return de_monthly_challenge_title(inputs)
	if (locale === "es") return es_monthly_challenge_title(inputs)
	if (locale === "fr") return fr_monthly_challenge_title(inputs)
	if (locale === "it") return it_monthly_challenge_title(inputs)
	if (locale === "ja") return ja_monthly_challenge_title(inputs)
	if (locale === "ko") return ko_monthly_challenge_title(inputs)
	if (locale === "pt_br") return pt_br_monthly_challenge_title(inputs)
	if (locale === "ru") return ru_monthly_challenge_title(inputs)
	if (locale === "th") return th_monthly_challenge_title(inputs)
	if (locale === "tr") return tr_monthly_challenge_title(inputs)
	if (locale === "zh_cn") return zh_cn_monthly_challenge_title(inputs)
	return zh_tw_monthly_challenge_title(inputs)
});